module.exports = __webpack_public_path__ + "static/media/wasabi-eth slp.240a695e.png";